import React from 'react';

import { TouchableOpacity, TouchableHighlight, TouchableWithoutFeedback, Text, View, Keyboard, Animated, ActivityIndicator } from 'react-native';
import { theme, style } from 'constants';
import { isWeb } from './platform';
const styles = style({
    content: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    text: {
        color: theme.primary_color,
        paddingHorizontal: 5
        //lineHeight:30
    }
});

export const keyboardDismiss = Keyboard.dismiss;
export const Link = ({
    highlight,
    touchable_no_feedback,
    style,
    children,
    color,
    size,
    title,
    selected,
    selected_color,
    title_style,
    content_style,
    icon,
    icon_size,
    icon_style,
    icon_attr,
    onPress,
    keyboardDismiss,
    disabled,
    animated,
    animatedContent,
    loading,
    ...props
}) => {
    const Size = size || 16;
    const Color = disabled ? theme.gray_color_lighten() : !highlight && selected ? selected_color || theme.primary_color : color || theme.gray_color;
    const Icon = icon;
    const Touchable = (highlight && TouchableHighlight) || (touchable_no_feedback && TouchableWithoutFeedback) || TouchableOpacity;
    const Content = animatedContent ? Animated.View : View;
    return (
        <Touchable
            style={[styles.holder, style, { borderColor: Color }, isWeb && { outline: 'none' }]}
            onPress={(...ar) => {
                keyboardDismiss && Keyboard.dismiss();
                onPress(...ar);
            }}
            disabled={disabled}
            {...props}
        >
            <Content style={[styles.content, highlight && selected && { backgroundColor: '#eee' }, content_style]}>
                {animated ? <Animated.View style={animated} /> : null}
                {icon ? <Icon size={icon_size || Size + 8} color={Color} selected={!highlight && selected} style={icon_style} {...icon_attr} /> : null}
                {title ? (
                    loading ? (
                        <ActivityIndicator color={color || theme.primary_color} />
                    ) : (
                        <Text style={[styles.text, title_style, { color: Color, fontSize: Size }]}>{title}</Text>
                    )
                ) : null}
                {children}
            </Content>
        </Touchable>
    );
};



// WEBPACK FOOTER //
// ./src/components/core/link.js